import { LocalizedPost, Post, PostFile } from "../models/index";

export default class Parser {
  static parse(type, data) {
    switch (type) {
      case "LocalizedPost":
        return this.fromJson(LocalizedPost, data);
      case "Post":
        return this.fromJson(Post, data);
      case "PostFile":
        return this.fromJson(PostFile, data);
      default:
        return data;
    }
  }
  static fromJson(type, data) {
    if (data === null) return null;
    if (data.constructor === Array) {
      const result = [];
      data.forEach((element) => {
        result.push(new type(element));
      });
      return result;
    }
    return new type(data);
  }
}
